import { createArtificialIdAlfanumerico } from '../../common/utils';

export interface TimeoutXPlanillaJSON {
  txp_id: string | null;
  txp_ppid: number;
  txp_eqid: number;
  txp_tiempo: number;
  txp_momento: string;
}

export class TimeoutXPlanilla {
  private idArtificialRef;
  protected constructor(
    private id: string | null,
    private ppid: number,
    private eqid: number,
    private tiempo: number,
    private momento: string,
    private hasBeenSaved: boolean
  ) {
    this.idArtificialRef = createArtificialIdAlfanumerico();
  }

  static createFrom(id: string | null, ppid: number, eqid: number, tiempo: number, momento: string) {
    return new this(id, ppid, eqid, tiempo, momento, false);
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: TimeoutXPlanilla) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: TimeoutXPlanillaJSON) {
    return TimeoutXPlanilla.createFrom(
      entity.txp_id,
      entity.txp_ppid,
      entity.txp_eqid,
      entity.txp_tiempo,
      entity.txp_momento
    );
  }

  toJSON(): TimeoutXPlanillaJSON {
    return {
      txp_id: this.getId(),
      txp_ppid: this.getPpid(),
      txp_eqid: this.getEqid(),
      txp_tiempo: this.getTiempo(),
      txp_momento: this.getMomento(),
    };
  }

  getId(): string | null {
    return this.id;
  }

  getIdArtifical(): string {
    return this.idArtificialRef;
  }

  getPpid(): number {
    return this.ppid;
  }

  getEqid(): number {
    return this.eqid;
  }

  getTiempo(): number {
    return this.tiempo;
  }

  getMomento(): string {
    return this.momento;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setPpid(value: number): void {
    this.ppid = value;
  }

  setEqid(value: number): void {
    this.eqid = value;
  }

  setTiempo(value: number): void {
    this.tiempo = value;
  }

  setMomento(value: string): void {
    this.momento = value;
  }

  saved(t: TimeoutXPlanilla) {
    this.hasBeenSaved = true;
    this.id = t.getId();
  }

  isSaved() {
    return this.hasBeenSaved;
  }
}
